// @generated by protobuf-ts 2.4.0 with parameter long_type_number,generate_dependencies,optimize_code_size,ts_nocheck,// @generated from protobuf file "apis/sparx/games/state/stickercollector/v1/stickercollector.proto" (package "sparx.games.state.stickercollector.v1", syntax proto3),// tslint:disable
// @ts-nocheck
import { MessageType } from '@protobuf-ts/runtime';
import { Timestamp } from '../../../../../../google/protobuf/timestamp';
//
// Picture Collector does not do any processing on the cloud, so the messages
// below are only here because they are expected by game.go

/**
 * @generated from protobuf message sparx.games.state.stickercollector.v1.Store
 */
export interface Store {
  /**
   * @generated from protobuf field: google.protobuf.Timestamp lastUpdatedTimestamp = 1;
   */
  lastUpdatedTimestamp?: Timestamp;
  /**
   * @generated from protobuf field: map<string, sparx.games.state.stickercollector.v1.StickerPackState> packStates = 2;
   */
  packStates: {
    [key: string]: StickerPackState;
  };
  /**
   * @generated from protobuf field: repeated string unlockedPacks = 3;
   */
  unlockedPacks: string[];
  /**
   * @generated from protobuf field: uint32 quizPhasesCompleted = 4;
   */
  quizPhasesCompleted: number;
  /**
   * @generated from protobuf field: repeated string packUnlockOrder = 5;
   */
  packUnlockOrder: string[];
}
/**
 * @generated from protobuf message sparx.games.state.stickercollector.v1.StickerPackState
 */
export interface StickerPackState {
  /**
   * The ID of every sticker that has been obtained
   *
   * @generated from protobuf field: repeated string unlockedStickers = 1;
   */
  unlockedStickers: string[];
  /**
   * How many times the player has filled the bar and earned a sticker packet
   *
   * @generated from protobuf field: uint64 attemptCount = 2;
   */
  attemptCount: number;
  /**
   * @generated from protobuf field: map<string, sparx.games.state.stickercollector.v1.StickerProgress> progressPerSticker = 3;
   */
  progressPerSticker: {
    [key: string]: StickerProgress;
  };
}
/**
 * @generated from protobuf message sparx.games.state.stickercollector.v1.StickerProgress
 */
export interface StickerProgress {
  /**
   * How many times the player has received the sticker
   *
   * @generated from protobuf field: uint64 collectedCount = 1;
   */
  collectedCount: number;
  /**
   * If true, the player has this sticker in "shiny" form (this is not yet
   * used in-game)
   *
   * @generated from protobuf field: bool hasFoundShiny = 2;
   */
  hasFoundShiny: boolean;
}
/**
 * @generated from protobuf message sparx.games.state.stickercollector.v1.State
 */
export interface State {}
/**
 * @generated from protobuf message sparx.games.state.stickercollector.v1.Init
 */
export interface Init {}
/**
 *
 * The only action fired by StickerCollector is a "quitGame" action, called when
 * the user presses an in-game "quit" button
 *
 * @generated from protobuf message sparx.games.state.stickercollector.v1.Action
 */
export interface Action {
  /**
   * the values that can be sent with an action
   *
   * @generated from protobuf field: sparx.games.state.stickercollector.v1.Action.ActionType actionType = 1;
   */
  actionType: Action_ActionType;
}
/**
 * the names of actions that can be sent
 *
 * @generated from protobuf enum sparx.games.state.stickercollector.v1.Action.ActionType
 */
export enum Action_ActionType {
  /**
   * @generated from protobuf enum value: quitGame = 0;
   */
  quitGame = 0,
}
/**
 * @generated from protobuf message sparx.games.state.stickercollector.v1.Update
 */
export interface Update {}
/**
 * @generated from protobuf message sparx.games.state.stickercollector.v1.Params
 */
export interface Params {}
// @generated message type with reflection information, may provide speed optimized methods
class Store$Type extends MessageType<Store> {
  constructor() {
    super('sparx.games.state.stickercollector.v1.Store', [
      {
        no: 1,
        name: 'lastUpdatedTimestamp',
        kind: 'message',
        T: () => Timestamp,
      },
      {
        no: 2,
        name: 'packStates',
        kind: 'map',
        K: 9 /*ScalarType.STRING*/,
        V: { kind: 'message', T: () => StickerPackState },
      },
      {
        no: 3,
        name: 'unlockedPacks',
        kind: 'scalar',
        repeat: 2 /*RepeatType.UNPACKED*/,
        T: 9 /*ScalarType.STRING*/,
      },
      {
        no: 4,
        name: 'quizPhasesCompleted',
        kind: 'scalar',
        T: 13 /*ScalarType.UINT32*/,
      },
      {
        no: 5,
        name: 'packUnlockOrder',
        kind: 'scalar',
        repeat: 2 /*RepeatType.UNPACKED*/,
        T: 9 /*ScalarType.STRING*/,
      },
    ]);
  }
}
/**
 * @generated MessageType for protobuf message sparx.games.state.stickercollector.v1.Store
 */
export const Store = new Store$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StickerPackState$Type extends MessageType<StickerPackState> {
  constructor() {
    super('sparx.games.state.stickercollector.v1.StickerPackState', [
      {
        no: 1,
        name: 'unlockedStickers',
        kind: 'scalar',
        repeat: 2 /*RepeatType.UNPACKED*/,
        T: 9 /*ScalarType.STRING*/,
      },
      {
        no: 2,
        name: 'attemptCount',
        kind: 'scalar',
        T: 4 /*ScalarType.UINT64*/,
        L: 2 /*LongType.NUMBER*/,
      },
      {
        no: 3,
        name: 'progressPerSticker',
        kind: 'map',
        K: 9 /*ScalarType.STRING*/,
        V: { kind: 'message', T: () => StickerProgress },
      },
    ]);
  }
}
/**
 * @generated MessageType for protobuf message sparx.games.state.stickercollector.v1.StickerPackState
 */
export const StickerPackState = new StickerPackState$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StickerProgress$Type extends MessageType<StickerProgress> {
  constructor() {
    super('sparx.games.state.stickercollector.v1.StickerProgress', [
      {
        no: 1,
        name: 'collectedCount',
        kind: 'scalar',
        T: 4 /*ScalarType.UINT64*/,
        L: 2 /*LongType.NUMBER*/,
      },
      {
        no: 2,
        name: 'hasFoundShiny',
        kind: 'scalar',
        T: 8 /*ScalarType.BOOL*/,
      },
    ]);
  }
}
/**
 * @generated MessageType for protobuf message sparx.games.state.stickercollector.v1.StickerProgress
 */
export const StickerProgress = new StickerProgress$Type();
// @generated message type with reflection information, may provide speed optimized methods
class State$Type extends MessageType<State> {
  constructor() {
    super('sparx.games.state.stickercollector.v1.State', []);
  }
}
/**
 * @generated MessageType for protobuf message sparx.games.state.stickercollector.v1.State
 */
export const State = new State$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Init$Type extends MessageType<Init> {
  constructor() {
    super('sparx.games.state.stickercollector.v1.Init', []);
  }
}
/**
 * @generated MessageType for protobuf message sparx.games.state.stickercollector.v1.Init
 */
export const Init = new Init$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Action$Type extends MessageType<Action> {
  constructor() {
    super('sparx.games.state.stickercollector.v1.Action', [
      {
        no: 1,
        name: 'actionType',
        kind: 'enum',
        T: () => [
          'sparx.games.state.stickercollector.v1.Action.ActionType',
          Action_ActionType,
        ],
      },
    ]);
  }
}
/**
 * @generated MessageType for protobuf message sparx.games.state.stickercollector.v1.Action
 */
export const Action = new Action$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Update$Type extends MessageType<Update> {
  constructor() {
    super('sparx.games.state.stickercollector.v1.Update', []);
  }
}
/**
 * @generated MessageType for protobuf message sparx.games.state.stickercollector.v1.Update
 */
export const Update = new Update$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Params$Type extends MessageType<Params> {
  constructor() {
    super('sparx.games.state.stickercollector.v1.Params', []);
  }
}
/**
 * @generated MessageType for protobuf message sparx.games.state.stickercollector.v1.Params
 */
export const Params = new Params$Type();
